import { getFragmentData } from "@/gen";
import { UpdateVideoForm_Video, useVideo } from "@/routes/video/queries";

export default function VideoThumbnail({
    videoId,
    alt,
    width,
    height,
}: {
    videoId: string;
    alt: string;
    width?: number | null;
    height?: number | null;
}) {
    const videoFragment = useVideo(videoId);

    const video = getFragmentData(UpdateVideoForm_Video, videoFragment.video);

    const fixedWidth = width != null && height != null ? width?.toFixed(0) : 450;
    const fixedHeight = width != null && height != null ? height?.toFixed(0) : 800;

    const imageThumbnailUrl = `https://image.mux.com/${video?.muxPlaybackId}/thumbnail.png?width=${fixedWidth}&height=${fixedHeight}`;

    return (
        <div>
            <img
                className="aspect-[9/16] w-full max-w-lg object-cover"
                src={imageThumbnailUrl}
                alt={alt}
            />
        </div>
    );
}
